export interface AnalyticsProvider {
    name: string;

    trackGameplayStart(): void;
    trackGameplayStop(): void;

    trackLoadingStart(): void;
    trackLoadingStop(): void;
}

class Analytics implements AnalyticsProvider {
    name = 'uber-analytics-provider';

    providers: AnalyticsProvider[] = [];
    registerProvider(p: AnalyticsProvider) {
        this.providers.push(p);
    }

    trackGameplayStart(): void {
        for (const p of this.providers) p.trackGameplayStart();
    }
    trackGameplayStop(): void {
        for (const p of this.providers) p.trackLoadingStop();
    }
    trackLoadingStart(): void {
        for (const p of this.providers) p.trackLoadingStart();
    }
    trackLoadingStop(): void {
        for (const p of this.providers) p.trackLoadingStop();
    }
}

export const analytics = new Analytics();
